module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_valutare_classe-83e13aed9c7a5c74d52b76255d8f537e.svg";